import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { FormData } from 'src/interfaces/iproptypes';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';

const SelectButton = ({
  actionKey,
  text,
  icon,
  isSelected,
  formData,
  setFormData,
}: {
  actionKey: string;
  text: string;
  icon: string;
  isSelected: boolean;
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}) => {
  return (
    <Box
      onClick={() => {
        setFormData({ ...formData, lookingTo: actionKey });
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        border: '1px solid #E0E0E0',
        borderRadius: '10px',
        padding: '10px',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#F0F0F0',
        },
        ...(isSelected && {
          backgroundColor: '#F0F0F0',
          border: '2px solid ' + COLOR_PRIMARY_2,
        }),
      }}
    >
      <Typography variant="body1" sx={{ fontSize: '30px' }}>
        {icon}
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '18px', fontWeight: 500 }}>
        {text}
      </Typography>
    </Box>
  );
};

const LookingToBuyOrSellFrom = ({
  location,
  formData,
  setFormData,
}: {
  location: string;
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}) => {
  return (
    <Box>
      <Typography variant="h3" sx={{ fontSize: '24px', textAlign: 'center' }}>
        Looking to Buy or Sell in {location}?
      </Typography>
      <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ mt: '20px' }}>
        <Grid item xs={6}>
          <SelectButton
            text="I'm Buying"
            icon="💡"
            isSelected={formData.lookingTo === 'buy'}
            actionKey="buy"
            formData={formData}
            setFormData={setFormData}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectButton
            text="I'm Selling"
            icon="🏷️"
            isSelected={formData.lookingTo === 'sell'}
            actionKey="sell"
            formData={formData}
            setFormData={setFormData}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LookingToBuyOrSellFrom;
